export default __webpack_public_path__ + "static/1414-6dea8751eb4486feae24151dfada943e.gif";